import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "device-admin-page" }
const _hoisted_2 = { class: "device-hero" }
const _hoisted_3 = { class: "device-hero__actions" }
const _hoisted_4 = { class: "device-table-card" }
const _hoisted_5 = { class: "toolbar" }
const _hoisted_6 = { class: "toolbar__actions" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_11 = {
  key: 0,
  class: "bind-info"
}
const _hoisted_12 = { class: "bind-info__title" }
const _hoisted_13 = {
  key: 0,
  class: "bind-info__sub"
}
const _hoisted_14 = {
  key: 1,
  class: "bind-info__sub"
}
const _hoisted_15 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_16 = { class: "pagination-row" }
const _hoisted_17 = {
  key: 0,
  class: "qrcode-preview-dialog"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "qrcode-preview-dialog__id" }

import { onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useApi } from '@/hooks/useApi';
import type { QrWifiDevice } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const loading = ref(false);
const addDialogVisible = ref(false);
const batchDialogVisible = ref(false);
const qrPreviewVisible = ref(false);
const previewDevice = ref<QrWifiDevice>();
const tableData = ref<QrWifiDevice[]>([]);
const total = ref(0);
const query = reactive({
  keyword: '',
  page: 1,
  pageSize: 10,
});
const form = reactive<Partial<QrWifiDevice>>({
  remark: '',
});
const batchForm = reactive({
  count: 1,
  remark: '',
});

const resetForm = () => {
  form.remark = '';
};

const hasBinding = (row: QrWifiDevice) => {
  const fields = [row.bind, row.wifiCodeId, row.storeName, row.ssid, row.ownerOpenid];
  return fields.some(Boolean);
};

const previewQrCode = (row: QrWifiDevice) => {
  previewDevice.value = row;
  qrPreviewVisible.value = true;
};

const resolveAssetUrl = (url?: string) => {
  const value = String(url || '').trim();
  if (!value) {
    return '';
  }
  if (/^https?:\/\//iu.test(value)) {
    return value;
  }
  const basePath = useApi().qrWifiApi.basePath || '';
  return `${basePath}${value.startsWith('/') ? value : `/${value}`}`;
};


const formatBinding = (row: QrWifiDevice) => {
  if (!hasBinding(row)) {
    return '未绑定';
  }
  return [
    row.storeName || row.bind?.storeName || row.ssid || row.bind?.ssid,
    row.wifiCodeId || row.bind?.wifiCodeId ? `店铺ID：${row.wifiCodeId || row.bind?.wifiCodeId}` : '',
    row.ownerOpenid || row.bind?.ownerOpenid || '',
  ].filter(Boolean).join(' / ');
};

const loadData = async() => {
  loading.value = true;
  try {
    const res = await useApi().qrWifiApi.pageDevices(query.keyword, query.page, query.pageSize);
    if (res.success && res.data) {
      tableData.value = res.data.data || [];
      total.value = res.data.total || 0;
    }
  } finally {
    loading.value = false;
  }
};

const openAdd = () => {
  resetForm();
  addDialogVisible.value = true;
};

const saveDevice = async() => {
  const res = await useApi().qrWifiApi.addDevice({ remark: form.remark });
  if (res.success) {
    ElMessage.success('添加成功，设备ID、二维码和 NFC_URL 已自动生成');
    addDialogVisible.value = false;
    await loadData();
  }
};

const openBatch = () => {
  batchForm.count = 1;
  batchForm.remark = '';
  batchDialogVisible.value = true;
};

const saveBatchDevices = async() => {
  if (!batchForm.count || batchForm.count < 1) {
    ElMessage.warning('请输入生成数量');
    return;
  }
  const res = await useApi().qrWifiApi.batchAddDevices({ count: batchForm.count, remark: batchForm.remark });
  if (res.success) {
    ElMessage.success('批量生成成功');
    batchDialogVisible.value = false;
    await loadData();
  }
};

const downloadFile = (url: string) => {
  const link = document.createElement('a');
  link.href = resolveAssetUrl(url);
  link.download = 'qrwifi-devices.zip';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const exportDeviceList = async() => {
  const res = await useApi().qrWifiApi.exportDevices(query.keyword);
  if (res.success && res.data) {
    downloadFile(res.data);
    ElMessage.success('已生成设备导出 zip 包');
  }
};

const removeDevice = async(row: QrWifiDevice) => {
  if (!row.id) {
    return;
  }
  await ElMessageBox.confirm(`确定删除设备「${row.id}」吗？删除后该设备绑定关系也会被移除。`, '删除设备确认', {
    type: 'warning',
    confirmButtonText: '确认删除',
    cancelButtonText: '取消',
  });
  const res = await useApi().qrWifiApi.deleteDevice(row.id);
  if (res.success) {
    ElMessage.success('删除成功');
    await loadData();
  }
};

onMounted(loadData);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, "QRWiFi Device"),
        _createElementVNode("h1", null, "设备管理"),
        _createElementVNode("p", { class: "description" }, "统一管理二维码与NFC设备。新增设备时只填写备注，设备ID、小程序二维码和 NFC_URL 由系统自动生成。")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: openAdd
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("添加设备", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "large",
          onClick: openBatch
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("批量添加", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "large",
          onClick: exportDeviceList
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("导出设备", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[16] || (_cache[16] = _createElementVNode("div", null, [
          _createElementVNode("h2", null, "设备列表"),
          _createElementVNode("p", null, "展示系统生成的设备ID、备注、小程序二维码、NFC_URL、绑定信息和创建时间。")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_input, {
            modelValue: query.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query.keyword) = $event)),
            clearable: "",
            placeholder: "搜索设备ID、备注或绑定信息",
            class: "search-input",
            onKeyup: _withKeys(loadData, ["enter"]),
            onClear: loadData
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, { onClick: loadData }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("搜索", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        border: "",
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "设备ID",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注",
            "min-width": "180"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(row.remark || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "二维码",
            width: "150",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (row.qrCodeUrl)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "device-qrcode",
                    onClick: ($event: any) => (previewQrCode(row))
                  }, [
                    _createElementVNode("img", {
                      class: "device-qrcode__img",
                      src: resolveAssetUrl(row.qrCodeUrl),
                      alt: "设备二维码"
                    }, null, 8, _hoisted_8),
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "device-qrcode__tip" }, "点击放大", -1))
                  ], 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "NFC_URL",
            "min-width": "320"
          }, {
            default: _withCtx(({ row }) => [
              (row.nfcUrl)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    href: row.nfcUrl,
                    type: "primary",
                    target: "_blank",
                    class: "scheme-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.nfcUrl), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "绑定信息",
            "min-width": "220"
          }, {
            default: _withCtx(({ row }) => [
              (hasBinding(row))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(row.storeName || row.bind?.storeName || row.ssid || row.bind?.ssid || '已绑定'), 1),
                    (row.wifiCodeId || row.bind?.wifiCodeId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, "店铺ID：" + _toDisplayString(row.wifiCodeId || row.bind?.wifiCodeId), 1))
                      : _createCommentVNode("", true),
                    (row.ownerOpenid || row.bind?.ownerOpenid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row.ownerOpenid || row.bind?.ownerOpenid), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "未绑定"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100",
            fixed: "right",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "danger",
                onClick: ($event: any) => (removeDevice(row))
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("删除", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_pagination, {
          "current-page": query.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((query.page) = $event)),
          "page-size": query.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((query.pageSize) = $event)),
          background: "",
          layout: "prev, pager, next, sizes, total",
          total: total.value,
          onCurrentChange: loadData,
          onSizeChange: loadData
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addDialogVisible).value = $event)),
      title: "添加设备",
      width: "520px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (addDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveDevice
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode("保存", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "设备ID、小程序二维码和 NFC_URL 将由后端自动生成。",
          type: "info",
          "show-icon": "",
          closable: false,
          class: "form-tip"
        }),
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.remark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.remark) = $event)),
                  placeholder: "请输入备注（可选）",
                  maxlength: "120",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchDialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((batchDialogVisible).value = $event)),
      title: "批量添加",
      width: "520px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (batchDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveBatchDevices
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode("批量生成", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "只需填写数量和一个备注，系统会批量生成设备ID、小程序二维码和 NFC_URL。导出时后端会生成包含 xlsx 和二维码图片的 zip 包。",
          type: "info",
          "show-icon": "",
          closable: false,
          class: "form-tip"
        }),
        _createVNode(_component_el_form, { "label-width": "96px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "生成数量",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: batchForm.count,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((batchForm.count) = $event)),
                  min: 1,
                  max: 500,
                  step: 1,
                  "controls-position": "right"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: batchForm.remark,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((batchForm.remark) = $event)),
                  placeholder: "请输入统一备注（可选）",
                  maxlength: "120",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: qrPreviewVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((qrPreviewVisible).value = $event)),
      title: "设备二维码",
      width: "420px",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        (previewDevice.value?.qrCodeUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("img", {
                class: "qrcode-preview-dialog__img",
                src: resolveAssetUrl(previewDevice.value.qrCodeUrl),
                alt: "设备二维码"
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, "设备ID：" + _toDisplayString(previewDevice.value.id), 1),
              _createVNode(_component_el_link, {
                href: resolveAssetUrl(previewDevice.value.qrCodeUrl),
                type: "primary",
                target: "_blank",
                class: "scheme-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(previewDevice.value.qrCodeUrl), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})